import ForgotPasswordRequestModelBase from '../_generated/modelBases/forgot-password-request-model-base';

export default class ForgotPasswordRequestModel extends ForgotPasswordRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
